import { render } from "./Section7Community.vue?vue&type=template&id=471dc362&ts=true"
import script from "./Section7Community.vue?vue&type=script&lang=ts"
export * from "./Section7Community.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__